import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"padding":"0 0.5rem"} }
const _hoisted_2 = { style: {"padding":"0 0.688rem"} }

import { computed, ref } from 'vue';
import {
  TirPmButton,
  TirPmButtonSizeEnum,
  TirPmButtonVariantEnum,
  TirPmModal,
} from 'tir-components';
import { TaskDialogEnum } from './enums';


export default /*#__PURE__*/_defineComponent({
  __name: 'task-dialog-modal',
  setup(__props, { expose: __expose }) {

const dialogType = ref<TaskDialogEnum>();

let callback: (confirm: boolean) => void | undefined = undefined;

/**Заголовок модального окна */
const title = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.ExitWithoutSaving:
      return 'Отменить создание?';
    case TaskDialogEnum.DataWillBeOverwritten:
      return 'Введенные данные будут изменены';
    case TaskDialogEnum.ImportedDataWillBeReset:
      return 'Импортированные данные будут сброшены';
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Отмена изменений';
  }
});

/**Текст контента */
const contentText = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Вы действительно хотите отменить все изменения, внесенны в описание?';
    default:
      return 'Если выйти сейчас, введенные данные не сохранятся';
  }
});

/**Текст кнопки подтверждения */
const confirmButtonText = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.ExitWithoutSaving:
      return 'Выйти';
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Остаться';
    case TaskDialogEnum.DataWillBeOverwritten:
    case TaskDialogEnum.ImportedDataWillBeReset:
      return 'Продолжить';
  }
});
/**Текст кнопки отмены */
const cancelButtonText = computed(() => {
  switch (dialogType.value) {
    case TaskDialogEnum.ExitWithoutSaving:
    case TaskDialogEnum.DataWillBeOverwritten:
    case TaskDialogEnum.ImportedDataWillBeReset:
      return 'Вернуться к редактированию';
    case TaskDialogEnum.CancelDescriptionChanges:
      return 'Отменить изменения';
  }
});

/**Открыть модальное окно */
const open = async (_dialogType: TaskDialogEnum) => {
  return new Promise<boolean>((resolve) => {
    callback = (confirm) => {
      resolve(confirm);
    };
    dialogType.value = _dialogType;
  });
};
/**Закрыть модальное окно */
const close = () => {
  dialogType.value = undefined;
  callback = undefined;
};

/**При выходе */
const cancel = () => {
  callback?.(false);
  close();
};

/**При отмене выхода */
const confirm = () => {
  callback?.(true);
  close();
};

__expose({
  open,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmModal), {
    "is-visible": dialogType.value !== undefined,
    title: title.value,
    "is-with-back": false,
    onClose: confirm
  }, {
    content: _withCtx(() => [
      _createTextVNode(_toDisplayString(contentText.value), 1)
    ]),
    footer: _withCtx(() => [
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).PrimaryState,
        onClick: cancel
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, _toDisplayString(cancelButtonText.value), 1)
        ]),
        _: 1
      }, 8, ["size", "variant"]),
      _createVNode(_unref(TirPmButton), {
        size: _unref(TirPmButtonSizeEnum).Regular,
        variant: _unref(TirPmButtonVariantEnum).SecondaryState,
        onClick: confirm
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, _toDisplayString(confirmButtonText.value), 1)
        ]),
        _: 1
      }, 8, ["size", "variant"])
    ]),
    _: 1
  }, 8, ["is-visible", "title"]))
}
}

})